import { render, staticRenderFns } from "./CultureHistoryIndex.vue?vue&type=template&id=a6d0dfec&scoped=true"
import script from "./CultureHistoryIndex.vue?vue&type=script&lang=js"
export * from "./CultureHistoryIndex.vue?vue&type=script&lang=js"
import style0 from "./CultureHistoryIndex.vue?vue&type=style&index=0&id=a6d0dfec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6d0dfec",
  null
  
)

export default component.exports